import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { IconCheckCircleOutline } from '@travel-frontend/icons';
import { List, ListItem } from '../../../../../../../../../primitives/index.js';
const formatDescription = ({
  name,
  type,
  value
}) => {
  if (type === 'bool') {
    return name;
  }
  return `${name}: ${value}`;
};
export const TooltipContent = ({
  data
}) => _jsx(List, {
  withIcons: true,
  children: data.filter(({
    name
  }, index) => data.findIndex(({
    name: name2
  }) => name === name2) === index).map((value, index) => {
    const label = formatDescription(value);
    return label ? _jsx(ListItem, {
      icon: _jsx(IconCheckCircleOutline, {}),
      size: "small",
      label: _jsx(Text, {
        preset: "labelXSmall",
        transform: "capitalize-first",
        children: formatDescription(value)
      })
    }, index) : null;
  })
});